import type { CustomAlgoliaSearchResults } from '@/domains/productDiscovery/Recommendation/interfaces/algolia';

export const filterResultsWithoutVatRate = (
  algoliaResults: CustomAlgoliaSearchResults[],
) => algoliaResults;
